// TODO: replace enum with values returned from API
export const FUND_TYPES = {
  afterTaxAnnuity: 'After Tax Annuity',
  annuityNonQualified: 'Non Qualified Annuity',
  /*Custom Portfolio Model === RetirePlus Pro*/
  customPortfolioModel: 'Custom Portfolio Models',
  fdicInsuredBankProduct: 'FDIC Insured Bank Product',
  fixedAnnuity: 'Fixed Annuity',
  fixedAnnuityTiaa: 'TIAA Fixed Annuity',
  fixedAnnuityTiaaQdia: 'TIAA QDIA Fixed Annuity',
  fixedAnnuityTiaaStableValue: 'TIAA Stable Value',
  lifeInsurance: 'Life Insurance',
  mFinancial: 'M Financial',
  mutualFund: 'Mutual Fund',
  none: 'None',
  otherInvestment: 'Other Investment',
  retirePlus: 'RetirePlus',
  retirePlusPro: 'RetirePlus Pro',
  variableAnnuity: 'Variable Annuity',
  variableAnnuityCref: 'CREF Variable Annuity',
  variableAnnuityTiaa: 'TIAA Variable Annuity',
  variableAnnuityTiaaAccess: 'TIAA Access Variable Annuity'
};

const fundTypeByFundTypeRawLower = {
  'after tax annuity': FUND_TYPES.afterTaxAnnuity,
  'non qualified annuity': FUND_TYPES.annuityNonQualified,
  'custom portfolio models': FUND_TYPES.customPortfolioModel,
  'fdic insured bank product': FUND_TYPES.fdicInsuredBankProduct,
  'fixed annuity': FUND_TYPES.fixedAnnuity,
  'tiaa fixed annuity': FUND_TYPES.fixedAnnuityTiaa,
  'tiaa qdia fixed annuity': FUND_TYPES.fixedAnnuityTiaaQdia,
  'tiaa stable value': FUND_TYPES.fixedAnnuityTiaaStableValue,
  'life insurance': FUND_TYPES.lifeInsurance,
  'm financial': FUND_TYPES.mFinancial,
  'mutual fund': FUND_TYPES.mutualFund,
  'other investment': FUND_TYPES.otherInvestment,
  retireplus: FUND_TYPES.retirePlus,
  'retireplus pro': FUND_TYPES.retirePlusPro,
  'variable annuity': FUND_TYPES.variableAnnuity,
  'cref variable annuity': FUND_TYPES.variableAnnuityCref,
  'tiaa variable annuity': FUND_TYPES.variableAnnuityTiaa,
  'tiaa access variable annuity': FUND_TYPES.variableAnnuityTiaaAccess
};

const getFundType = (fundTypeRaw = '') =>
  fundTypeByFundTypeRawLower[fundTypeRaw.toLowerCase()] ||
  FUND_TYPES.none;

export default getFundType;
